import React from "react";
import {
    Box,
    Container,
    Grid,
    Typography,
    TextField,
    IconButton,
    Button,
} from "@mui/material";

import { FaInstagram, FaWhatsapp, FaFacebookF } from "react-icons/fa";

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: "var(--azul)",
                color: "white",
                mt: 0,
                pt: 10,
                pb: 4,
            }}
        >
            <Container maxWidth="xl">
                <Grid container spacing={6}>
                    {/* COLUNA 1 - LOGO / DESCRIÇÃO */}
                    <Grid item xs={12} md={4}>
                        <Typography
                            sx={{
                                fontSize: 28,
                                fontWeight: 800,
                                letterSpacing: 1,
                                mb: 2,
                            }}
                        >
                            EMMA
                        </Typography>

                        <Typography sx={{ opacity: 0.85, lineHeight: 1.6, width: { xs: "100%", md: "50%" } }}>
                            Sabor, autenticidade e tecnologia.
                            A EMMA eleva o padrão dos Pods e Vapes no Brasil —
                            uma experiência premium do clique ao primeiro puff.
                        </Typography>
                    </Grid>

                    {/* COLUNA 2 - LINKS */}
                    <Grid item xs={12} sm={6} md={2}>
                        <Typography sx={{ fontWeight: 700, mb: 2 }}>Institucional</Typography>

                        {["Home", "Produtos", "Sobre", "Contato", "Minha Conta"].map((item) => (
                            <Typography
                                key={item}
                                sx={{
                                    opacity: 0.8,
                                    mb: 1,
                                    cursor: "pointer",
                                    transition: "0.2s",
                                    "&:hover": { opacity: 1, textDecoration: "underline" },
                                }}
                            >
                                {item}
                            </Typography>
                        ))}
                    </Grid>

                    {/* COLUNA 3 - AJUDA */}
                    <Grid item xs={12} sm={6} md={2}>
                        <Typography sx={{ fontWeight: 700, mb: 2 }}>Suporte</Typography>

                        {["Política de Trocas", "Privacidade", "Garantias", "Ajuda"].map(
                            (item) => (
                                <Typography
                                    key={item}
                                    sx={{
                                        opacity: 0.8,
                                        mb: 1,
                                        cursor: "pointer",
                                        transition: "0.2s",
                                        "&:hover": { opacity: 1, textDecoration: "underline" },
                                    }}
                                >
                                    {item}
                                </Typography>
                            )
                        )}
                    </Grid>

                    {/* COLUNA 4 - NEWSLETTER */}

                </Grid>

                {/* DIVISÓRIA */}
                <Box
                    sx={{
                        width: "100%",
                        height: "1px",
                        backgroundColor: "rgba(255,255,255,0.15)",
                        my: 5,
                    }}
                />

                {/* REDES + COPYRIGHT */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 3,
                    }}
                >
                    {/* REDES SOCIAIS */}
                    <Box sx={{ display: "flex", gap: 2 }}>
                        {[FaInstagram, FaWhatsapp, FaFacebookF].map((Icon, i) => (
                            <IconButton
                                key={i}
                                sx={{
                                    color: "white",
                                    backgroundColor: "rgba(255,255,255,0.08)",
                                    "&:hover": {
                                        backgroundColor: "rgba(255,255,255,0.2)",
                                    },
                                }}
                            >
                                <Icon size={20} />
                            </IconButton>
                        ))}
                    </Box>

                    {/* COPYRIGHT */}
                    <Typography sx={{ opacity: 0.7, textAlign: "center" }}>
                        © {new Date().getFullYear()} EMMA Pods — Todos os direitos reservados.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
